import { del, get, post, put } from "./client";
import type {
  AgentDeployResult,
  AgentTokenResetResult,
  AgentUninstallResult,
  DbConnection,
  DbConnectionCreate,
  Paginated,
} from "@/types";

export interface ItemsResponse {
  items: string[];
}

export interface TestResponse {
  ok: boolean;
  message: string;
}

export interface ListDbConnectionsParams {
  limit?: number;
  offset?: number;
}

export async function listDbConnections(
  params: ListDbConnectionsParams = {},
): Promise<Paginated<DbConnection>> {
  const query = new URLSearchParams();
  if (params.limit !== undefined) {
    query.set("limit", String(params.limit));
  }
  if (params.offset !== undefined) {
    query.set("offset", String(params.offset));
  }
  const qs = query.toString();
  return get<Paginated<DbConnection>>(`/db-connections${qs ? `?${qs}` : ""}`);
}

export async function createDbConnection(
  connection: DbConnectionCreate,
): Promise<DbConnection> {
  return post<DbConnection>("/db-connections", connection);
}

export async function updateDbConnection(
  id: string,
  connection: DbConnectionCreate,
): Promise<DbConnection> {
  return put<DbConnection>(`/db-connections/${id}`, connection);
}

export async function deleteDbConnection(id: string): Promise<void> {
  return del(`/db-connections/${id}`);
}

export async function testDbConnection(id: string): Promise<TestResponse> {
  return post<TestResponse>(`/db-connections/${id}/test`, {});
}

export async function listDbSchemas(id: string): Promise<ItemsResponse> {
  return get<ItemsResponse>(`/db-connections/${id}/schemas`);
}

export async function listDbTables(
  id: string,
  schema = "public",
): Promise<ItemsResponse> {
  return get<ItemsResponse>(`/db-connections/${id}/tables?schema=${encodeURIComponent(schema)}`);
}

export async function listDbFunctions(
  id: string,
  schema = "public",
): Promise<ItemsResponse> {
  return get<ItemsResponse>(`/db-connections/${id}/functions?schema=${encodeURIComponent(schema)}`);
}

export async function deployAgent(id: string): Promise<AgentDeployResult> {
  return post<AgentDeployResult>(`/db-connections/${id}/deploy-agent`, {});
}

export async function resetAgentToken(id: string): Promise<AgentTokenResetResult> {
  return post<AgentTokenResetResult>(`/db-connections/${id}/reset-agent-token`, {});
}

export async function uninstallAgent(id: string): Promise<AgentUninstallResult> {
  return post<AgentUninstallResult>(`/db-connections/${id}/uninstall-agent`, {});
}
